let SHOW_COUNTS = false
/**

"html-to-rtf": "^1.3.0",
import { Rtf } from 'html-to-rtf/src/rtf/rtf.class'

var htmlToRtf = require('html-to-rtf')
htmlToRtf.convertHtmlToRtf(activityAnswer.text)

var htmlToRtf = require('html-to-rtf')
htmlToRtf.convertHtmlToRtf(activityAnswer.text)
function findLevelByAnswers(activityId,levels,answers) { ...
    
  */
 const Office = window.Office

 //'<p>Level ' + indicator.score + '</p><p><i>' + indicator.text + '</i></p>'
 function formatIndicator(indicator) {
   return '<p><i>' + indicator.text + '</i></p>'
 }
 
 //'<tr><td>' + level.name + '</td><td>' 
 function formatLevel(level) {
   return '<p>' + formatIndicator(level.indicator) 
     + (level.text ? level.text : '')   +  '<p>'
 }
 
 function formatCp(cp) {
 
   return '<table style="border: 1px solid; border-collapse: collapse; border-spacing: 0">' 
     + '<thead><tr style="background: black; color:white; text-align: center"><th style="border: 1px solid white">Competency</th><th style="border: 1px solid white">Level (1-5)</th><th style="border: 1px solid white">Proficiency Level</th></tr></thead>' 
     + '<tbody><tr><td style="border: 1px solid; text-align: center; font-weight: bold">'+ cp.name + '</td>'
     + '<td style="border: 1px solid; text-align: center; font-weight: bold">' + cp.rating + '</td>'
     + '<td style="border: 1px solid; font: bold; text-align: center; font-weight: bold"></td></tr>' 
     + '<tr><td colspan="3" style="border: 1px solid black; background: gray; color:white; text-align: center;">Online Assessment</td></tr>'
     + '<tr><td colspan="3" style="padding: 10px">&nbsp;</td></tr>'
     + '<tr><td colspan="3" style="border: 1px solid black; background: gray; color:white; text-align: center;">Assessment Center Exercises</td></tr>'        
     + '<tr><td colspan="3" style="border: 1px solid black; padding: 10px">'
     + ( cp.levels ? cp.levels.map(formatLevel).join('') : '' )
     + '</td></tr>'
     + '<tr><td colspan="3" style="border: 1px solid black; background: gray; color:white; text-align: center;">Interview</td></tr>'
     + '<tr><td colspan="3" style="padding: 10px">&nbsp;</td></tr>'
     + '</tbody></table><br />'
 }
 
 function strengthFilter(cp) {
   return cp.rating > 3
 }
 function developmentFilter(cp) {
   return cp.rating <= 3
 }
 
 function formatRatingLevel(rating) {
   if (rating >= 1 && rating < 2) return 'Novice'
   if (rating >= 2 && rating < 3) return 'Basic'
   if (rating >= 3 && rating < 4) return 'Proficient'
   if (rating >= 4 && rating < 4.5) return 'Advanced'
   if (rating >= 4) return 'Expert'
   return ''
 }
 
 
 function formatRatingSummary(activities,overallRating) {
   const ratings = [
     { description: 'Expert', min: 4.50, max: 5.00},
     { description: 'Advanced', min: 4.00, max: 4.49},
     { description: 'Proficient', min: 3.00, max: 3.99},
     { description: 'Basic', min: 2.00, max: 2.99},
     { description: 'Expert', min: 1.00, max: 1.99},
   ]
   return '<table style="border: 1px solid; border-collapse: collapse; border-spacing: 0">' 
     + '<thead><tr style="background: black; color:white; text-align: center"><th style="border: 1px solid white">Competency</th><th style="border: 1px solid white">Rating</th><th style="border: 1px solid white">Proficiency Level</th></tr></thead>' 
     + '<tbody>'
     + activities.map(activity => activity.competencies 
           ? activity.competencies.map(cp => {
                   return '<tr><td style="border: 1px solid; text-align: center; font-weight: bold">'+ cp.name + '</td>'
                       + '<td style="border: 1px solid; text-align: center; font-weight: bold">' + cp.rating + '</td>'
                       + '<td style="border: 1px solid; font: bold; text-align: center; font-weight: bold">' + cp.ratingLevel + '</td></tr>' 
                 }).join('') 
             : ''
     ).join('')
   + '<tr><td style="border: 1px solid; text-align: center; font-weight: bold">TOTAL AVERAGE</td>'
   + '<td style="border: 1px solid; text-align: center; font-weight: bold">' + overallRating + '</td>'
   + '<td style="border: 1px solid; font: bold; text-align: center; font-weight: bold">' + formatRatingLevel(overallRating) + '</td></tr>'
   + '</tbody></table><br />'
   + '<p style="font-family: Arial">Rating interpretation</p>'
   + '<table><thead><tr><th style="text-align: center; font-weight: bold">Rating</th><th style="text-align: center; font-weight: bold">Description</th></tr></thead><tbody>'
   + ratings.map(rating => '<tr><td style="text-align: center">' + rating.min + ' — ' + rating.max  + '</td><td style="text-align: center">' + rating.description +'</td></tr>').join('')
   + '</tbody></table><br/><br/><br/><br/><br/><br/>'
   + '<h1 style="font-family: Arial; font-weight: bold; color: rgb(0,112,192)">Overall Summary</h1>'
 }
 
 // '<h1>' + activity.name + '</h1>' 
 function formatActivity(activity) {
 
   return (activity.competencies
     ? '<div style="background: rgb(223,122,0); color: white; page-break-before: always"><h1 style="font-family: Arial; font-weight: bold">Strengths</h1></div>'
     + activity.competencies.filter(strengthFilter).map(formatCp).join('')
     + '<div style="background: rgb(223,122,0); color: white"><h1 style="font-family: Arial; font-weight: bold">DevelopmentalAreas</h1></div>' 
     + activity.competencies.filter(developmentFilter).map(formatCp).join('')
     : '') + '<br />'
 }
 
   //var htmlToRtf = require('html-to-rtf')
   //htmlToRtf.convertHtmlToRtf(activityAnswer.text)
 function findLevelByAnswers(activityId,levels,answers) {
   return levels.map(level => {
     const activityAnswer = answers.find(answer => answer.activityId === activityId && answer.levelId === level.id)
     const levelIndicator = level.indicators.find(indicator => indicator.id === activityAnswer.indicatorId )
     return { id: level.id, name: level.name, indicator: levelIndicator, text: activityAnswer.text  }
     
   })
 }
 
 function computeRating(levels) {
   let total = 0
   let count = 0
   levels.map(level => {
     total += (level.indicator.score * 1)
     count++
     return level
   })
   return count > 0 ? parseFloat(Math.round(total/count * 100) / 100).toFixed(2) : 0
 }
 
 
 function findCpByAnswers(cp,activityId,answers) {
   const levels = findLevelByAnswers(activityId,cp.levels,answers)
   const rating = computeRating(levels)
   const ratingLevel = formatRatingLevel(rating) 
   return {
       id: cp.id,
       name: cp.name,
       levels,
       rating,
       ratingLevel
   }
 }
 
 
 function filterActivityByAnswers(activity,answers) {
     return activity.competencies
       ? { id: activity.id, name: activity.name,
           competencies: activity.competencies.map( cp => findCpByAnswers(cp,activity.id,answers) ) 
       }
       :  { id: activity.id, name: activity.name }
      
 }
 function computeOverallRating(activities) {
   let total = 0
   let count = 0
   activities.map(activity => { 
     return activity.competencies 
       ? activity.competencies.map(cp => {
           total += (cp.rating * 1)
           count++ 
           return cp
         }) 
     : activity 
 })
   return count > 0 ? parseFloat(Math.round(total/count * 100) / 100).toFixed(2) : 0
 }
 
 function formatDate(date) {
   var monthNames = [
     "January", "February", "March",
     "April", "May", "June", "July",
     "August", "September", "October",
     "November", "December"
   ];
 
   var day = date.getDate();
   var monthIndex = date.getMonth();
   var year = date.getFullYear();
 
   return monthNames[monthIndex] + ' ' + day + ', ' +  year;
 }
 // ' + assessment.employee.firstName + ' ' + assessment.employee.lastName + '
 function formatAssessment(assessment) {

  const activities = assessment.activities
  const answers = assessment.answers
  const participant = assessment.id
  //const dateToday = Date.now()
  const formattedDate = formatDate(new Date())

  const filteredActivities = activities
          .map(activity => filterActivityByAnswers(activity,answers))
  const ratingSummary =  formatRatingSummary(filteredActivities,overallRating)
   
  const overallRating = computeOverallRating(filteredActivities)
  const ratingLevel = formatRatingLevel(overallRating)
  const formattedFilteredActivities = filteredActivities.map(formatActivity).join('<br/>')

   return `<h1 style="font-family: Arial; font-weight: bold; color: rgb(0,112,192)">Executive Summary</h1>
          <div style="page-break-before: always"><strong>Participant:  ${participant} </strong></div>
        <div><strong>Date of Assessment:</strong>${formattedDate}</div>
        ${ratingSummary}
        <div style="page-break-before: always"><strong>Overall Level of Competency: ${ratingLevel}</div>
        ${formattedFilteredActivities}`
 }
 
 
 
 function insertWordTable(assessment)  {
   const data = formatAssessment(assessment)
   
   Office.context.document.setSelectedDataAsync(data, {coercionType: Office.CoercionType.Html});
 }
 

 function debugCp(cps,showCounts) {
  SHOW_COUNTS = showCounts

  cps.map(cp => console.log(cp.id + ' ' + cp.name + ' ' + cp.sort + cp.activities.map(act => console.log({id :act.id, cpIds: act.cpIds}  ) )) ) 
} 


/**
 * From utils/office.js
 */
 const insertWordTableDispatch = (cps, showCounts, dispatch) => {
  SHOW_COUNTS = showCounts

  //const data = cps.map(formatCp).join('<br/>')
  const data = cps.map(debugCp).join('<br/>')

  dispatch( {type:'ASYNC_SUCCEED', message:"Started 2"});
  Office.context.document.setSelectedDataAsync(data, {coercionType: Office.CoercionType.Html},
    function (asyncResult) {
      dispatch( {type:'ASYNC_SUCCEED', message:"Started 3"});
      if (asyncResult.status === Office.AsyncResultStatus.Succeeded) {
                dispatch( {type:'ASYNC_SUCCEED', message:"Succeeded"});
              } else {
                dispatch( {type:'ASYNC_FAILED', message:asyncResult.error.message});
              }
  })
}

 export default insertWordTable


// WEBPACK FOOTER //
// ./src/assessments/utils/gci-trial/office.js